import { jsx as s } from "react/jsx-runtime";
import '../../assets/Description.css';const r = "_description_adphr_1", t = {
  description: r
}, c = ({ copyDescription: i }) => /* @__PURE__ */ s("div", { className: `${t.description} iOSPWA-description`, children: i });
export {
  c as Description
};
